export const Lines: any[] = [
  {
    line: '1',
    filePath: 'assets/geojson/line-routes/LINEA_1.geojson'
  },
  {
    line: '01',
    filePath: 'assets/geojson/line-routes/LINEA_01.geojson',
    type: 'Microbus | Minibus | Taxi trufi'
  },
  {
    line: '2',
    filePath: 'assets/geojson/line-routes/LINEA_2.geojson'
  },
  {
    line: '3',
    filePath: 'assets/geojson/line-routes/LINEA_3.geojson'
  },
  {
    line: '03',
    filePath: 'assets/geojson/line-routes/LINEA_03.geojson'
  },
  {
    line: '5',
    filePath: 'assets/geojson/line-routes/LINEA_5.geojson'
  },
  {
    line: '6',
    filePath: 'assets/geojson/line-routes/LINEA_6.geojson'
  },
  {
    line: '8',
    filePath: 'assets/geojson/line-routes/LINEA_8.geojson'
  },
  {
    line: '9',
    filePath: 'assets/geojson/line-routes/LINEA_9.geojson'
  },
  {
    line: '10',
    filePath: 'assets/geojson/line-routes/LINEA_10.geojson'
  },
  {
    line: '010',
    filePath: 'assets/geojson/line-routes/LINEA_010.geojson'
  },
  {
    line: '11',
    filePath: 'assets/geojson/line-routes/LINEA_11.geojson'
  },
  {
    line: '012',
    filePath: 'assets/geojson/line-routes/LINEA_012.geojson'
  },
  {
    line: '13',
    filePath: 'assets/geojson/line-routes/LINEA_13.geojson'
  },
  {
    line: '15',
    filePath: 'assets/geojson/line-routes/LINEA_15.geojson'
  },
  {
    line: '16',
    filePath: 'assets/geojson/line-routes/LINEA_16.geojson'
  },
  {
    line: '17',
    filePath: 'assets/geojson/line-routes/LINEA_17.geojson'
  },
  {
    line: '18',
    filePath: 'assets/geojson/line-routes/LINEA_18.geojson'
  },
  {
    line: '19',
    filePath: 'assets/geojson/line-routes/LINEA_19.geojson'
  },
  {
    line: '20',
    filePath: 'assets/geojson/line-routes/LINEA_20.geojson'
  },
  {
    line: '27',
    filePath: 'assets/geojson/line-routes/LINEA_27.geojson'
  },
  {
    line: '31',
    filePath: 'assets/geojson/line-routes/LINEA_31.geojson'
  },
  {
    line: '35',
    filePath: 'assets/geojson/line-routes/LINEA_35.geojson'
  },
  {
    line: '36',
    filePath: 'assets/geojson/line-routes/LINEA_36.geojson'
  },
  {
    line: '40',
    filePath: 'assets/geojson/line-routes/LINEA_40.geojson'
  },
  {
    line: '43',
    filePath: 'assets/geojson/line-routes/LINEA_43.geojson'
  },
  {
    line: '45',
    filePath: 'assets/geojson/line-routes/LINEA_45.geojson'
  },
  {
    line: '46',
    filePath: 'assets/geojson/line-routes/LINEA_46.geojson'
  },
  {
    line: '51',
    filePath: 'assets/geojson/line-routes/LINEA_51.geojson'
  },
  {
    line: '52',
    filePath: 'assets/geojson/line-routes/LINEA_52.geojson'
  },
  {
    line: '101',
    filePath: 'assets/geojson/line-routes/LINEA_101.geojson'
  },
  {
    line: '102',
    filePath: 'assets/geojson/line-routes/LINEA_102.geojson'
  },
  {
    line: '103',
    filePath: 'assets/geojson/line-routes/LINEA_103.geojson'
  },
  {
    line: '104',
    filePath: 'assets/geojson/line-routes/LINEA_104.geojson'
  },
  {
    line: '106',
    filePath: 'assets/geojson/line-routes/LINEA_106.geojson'
  },
  {
    line: '107',
    filePath: 'assets/geojson/line-routes/LINEA_107.geojson'
  },
  {
    line: '108',
    filePath: 'assets/geojson/line-routes/LINEA_108.geojson'
  },
  {
    line: '109',
    filePath: 'assets/geojson/line-routes/LINEA_109.geojson'
  },
  {
    line: '110',
    filePath: 'assets/geojson/line-routes/LINEA_110.geojson'
  },
  {
    line: '111',
    filePath: 'assets/geojson/line-routes/LINEA_111.geojson'
  },
  {
    line: '112',
    filePath: 'assets/geojson/line-routes/LINEA_112.geojson'
  },
  {
    line: '113',
    filePath: 'assets/geojson/line-routes/LINEA_113.geojson'
  },
  {
    line: '114',
    filePath: 'assets/geojson/line-routes/LINEA_114.geojson'
  },
  {
    line: '115',
    filePath: 'assets/geojson/line-routes/LINEA_115.geojson'
  },
  {
    line: '116',
    filePath: 'assets/geojson/line-routes/LINEA_116.geojson'
  },
  {
    line: '118',
    filePath: 'assets/geojson/line-routes/LINEA_118.geojson'
  },
  {
    line: '119',
    filePath: 'assets/geojson/line-routes/LINEA_119.geojson'
  },
  {
    line: '120',
    filePath: 'assets/geojson/line-routes/LINEA_120.geojson'
  },
  {
    line: '121',
    filePath: 'assets/geojson/line-routes/LINEA_121.geojson'
  },
  {
    line: '122',
    filePath: 'assets/geojson/line-routes/LINEA_122.geojson'
  },
  {
    line: '123',
    filePath: 'assets/geojson/line-routes/LINEA_123.geojson'
  },
  {
    line: '125',
    filePath: 'assets/geojson/line-routes/LINEA_125.geojson'
  },
  {
    line: '130',
    filePath: 'assets/geojson/line-routes/LINEA_130.geojson'
  },
  {
    line: '131',
    filePath: 'assets/geojson/line-routes/LINEA_131.geojson'
  },
  {
    line: '132',
    filePath: 'assets/geojson/line-routes/LINEA_132.geojson'
  },
  {
    line: '133',
    filePath: 'assets/geojson/line-routes/LINEA_133.geojson'
  },
  {
    line: '134',
    filePath: 'assets/geojson/line-routes/LINEA_134.geojson'
  },
  {
    line: '135',
    filePath: 'assets/geojson/line-routes/LINEA_135.geojson'
  },
  {
    line: '136',
    filePath: 'assets/geojson/line-routes/LINEA_136.geojson'
  },
  {
    line: '138',
    filePath: 'assets/geojson/line-routes/LINEA_138.geojson'
  },
  {
    line: '148',
    filePath: 'assets/geojson/line-routes/LINEA_148.geojson'
  },
  {
    line: '150',
    filePath: 'assets/geojson/line-routes/LINEA_150.geojson'
  },
  {
    line: '160',
    filePath: 'assets/geojson/line-routes/LINEA_160.geojson'
  },
  {
    line: '200',
    filePath: 'assets/geojson/line-routes/LINEA_200.geojson'
  },
  {
    line: '201',
    filePath: 'assets/geojson/line-routes/LINEA_201.geojson'
  },
  {
    line: '202',
    filePath: 'assets/geojson/line-routes/LINEA_202.geojson'
  },
  {
    line: '203',
    filePath: 'assets/geojson/line-routes/LINEA_203.geojson'
  },
  {
    line: '204',
    filePath: 'assets/geojson/line-routes/LINEA_204.geojson'
  },
  {
    line: '205',
    filePath: 'assets/geojson/line-routes/LINEA_205.geojson'
  },
  {
    line: '206',
    filePath: 'assets/geojson/line-routes/LINEA_206.geojson'
  },
  {
    line: '207',
    filePath: 'assets/geojson/line-routes/LINEA_207.geojson'
  },
  {
    line: '208',
    filePath: 'assets/geojson/line-routes/LINEA_208.geojson'
  },
  {
    line: '209',
    filePath: 'assets/geojson/line-routes/LINEA_209.geojson'
  },
  {
    line: '210',
    filePath: 'assets/geojson/line-routes/LINEA_210.geojson'
  },
  {
    line: '211',
    filePath: 'assets/geojson/line-routes/LINEA_211.geojson'
  },
  {
    line: '212',
    filePath: 'assets/geojson/line-routes/LINEA_212.geojson'
  },
  {
    line: '217',
    filePath: 'assets/geojson/line-routes/LINEA_217.geojson'
  },
  {
    line: '220',
    filePath: 'assets/geojson/line-routes/LINEA_220.geojson'
  },
  {
    line: '230',
    filePath: 'assets/geojson/line-routes/LINEA_230.geojson'
  },
  {
    line: '232',
    filePath: 'assets/geojson/line-routes/LINEA_232.geojson'
  },
  {
    line: '233',
    filePath: 'assets/geojson/line-routes/LINEA_233.geojson'
  },
  {
    line: '240',
    filePath: 'assets/geojson/line-routes/LINEA_240.geojson'
  },
  {
    line: '241',
    filePath: 'assets/geojson/line-routes/LINEA_241.geojson'
  },
  {
    line: '242',
    filePath: 'assets/geojson/line-routes/LINEA_242.geojson'
  },
  {
    line: '244',
    filePath: 'assets/geojson/line-routes/LINEA_244.geojson'
  },
  {
    line: '245',
    filePath: 'assets/geojson/line-routes/LINEA_245.geojson'
  },
  {
    line: '250',
    filePath: 'assets/geojson/line-routes/LINEA_250.geojson'
  },
  {
    line: '252',
    filePath: 'assets/geojson/line-routes/LINEA_252.geojson'
  },
  {
    line: '260',
    filePath: 'assets/geojson/line-routes/LINEA_260.geojson'
  },
  {
    line: '261',
    filePath: 'assets/geojson/line-routes/LINEA_261.geojson'
  },
  {
    line: '265',
    filePath: 'assets/geojson/line-routes/LINEA_265.geojson'
  },
  {
    line: '270',
    filePath: 'assets/geojson/line-routes/LINEA_270.geojson'
  },
  {
    line: '290',
    filePath: 'assets/geojson/line-routes/LINEA_290.geojson'
  },
  {
    line: '311',
    filePath: 'assets/geojson/line-routes/LINEA_311.geojson'
  },
  {
    line: '1001',
    filePath: 'assets/geojson/line-routes/LINEA_1001.geojson'
  },
  {
    line: '3V',
    filePath: 'assets/geojson/line-routes/LINEA_3V.geojson'
  },
  {
    line: 'A',
    filePath: 'assets/geojson/line-routes/LINEA_A.geojson'
  },
  {
    line: 'B',
    filePath: 'assets/geojson/line-routes/LINEA_B.geojson'
  },
  {
    line: 'C',
    filePath: 'assets/geojson/line-routes/LINEA_C.geojson'
  },
  {
    line: 'E',
    filePath: 'assets/geojson/line-routes/LINEA_E.geojson'
  },
  {
    line: 'G',
    filePath: 'assets/geojson/line-routes/LINEA_G.geojson'
  },
  {
    line: 'H',
    filePath: 'assets/geojson/line-routes/LINEA_H.geojson'
  },
  {
    line: 'I',
    filePath: 'assets/geojson/line-routes/LINEA_I.geojson'
  },
  {
    line: 'J',
    filePath: 'assets/geojson/line-routes/LINEA_J.geojson'
  },
  {
    line: 'K',
    filePath: 'assets/geojson/line-routes/LINEA_K.geojson'
  },
  {
    line: 'LL',
    filePath: 'assets/geojson/line-routes/LINEA_LL.geojson'
  },
  {
    line: 'M',
    filePath: 'assets/geojson/line-routes/LINEA_M.geojson'
  },
  {
    line: 'N',
    filePath: 'assets/geojson/line-routes/LINEA_N.geojson'
  },
  {
    line: 'O',
    filePath: 'assets/geojson/line-routes/LINEA_O.geojson'
  },
  {
    line: 'P',
    filePath: 'assets/geojson/line-routes/LINEA_P.geojson'
  },
  {
    line: 'Q',
    filePath: 'assets/geojson/line-routes/LINEA_Q.geojson'
  },
  {
    line: 'R',
    filePath: 'assets/geojson/line-routes/LINEA_R.geojson'
  },
  {
    line: 'S',
    filePath: 'assets/geojson/line-routes/LINEA_S.geojson'
  },
  {
    line: 'T',
    filePath: 'assets/geojson/line-routes/LINEA_T.geojson'
  },
  {
    line: 'U',
    filePath: 'assets/geojson/line-routes/LINEA_U.geojson'
  },
  {
    line: 'W',
    filePath: 'assets/geojson/line-routes/LINEA_W.geojson'
  },
  {
    line: 'X10',
    filePath: 'assets/geojson/line-routes/LINEA_X10.geojson'
  },
  {
    line: 'Y',
    filePath: 'assets/geojson/line-routes/LINEA_Y.geojson'
  },
  {
    line: 'Z12',
    filePath: 'assets/geojson/line-routes/LINEA_Z12.geojson'
  },
  {
    line: 'Z14',
    filePath: 'assets/geojson/line-routes/LINEA_Z14.geojson'
  }
]